export default __webpack_public_path__ + "static/media/444.a107c180.png";